import { Tabs, TabsProps } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { CorePageLayoutTabsPrefix } from '../hooks/useTabsTabIndexReset';

const StyledAffixTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    &:before {
      border-bottom: none;
    }
  }
  &.ant-tabs-large .ant-tabs-tab,
  .ant-tabs-tab {
    padding-top: 5px;
    padding-bottom: 10px;

    // per accessibilità
    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      /* text-shadow: 0 0 0.25px ${props => props.theme.colorPrimary}; */
      text-shadow: none;
      color: ${props => props.theme.colorPrimaryActive};
    }
  }
`;

export interface AffixTabsProps extends TabsProps {
  affixed?: boolean;
}

/**
 * Tabs di navigazione inseriti nella fascia del titolo,
 * affissi alla testa della pagina.
 */
export function AffixTabs(props: AffixTabsProps) {
  const { affixed, className, ...tabsProps } = props;
  return (
    <StyledAffixTabs
      id={`${CorePageLayoutTabsPrefix}header`}
      className={clx(className, { affixed })}
      size={affixed ? 'middle' : 'large'}
      {...tabsProps}
    />
  );
}
